import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6235dfa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]




export default /*#__PURE__*/_defineComponent({
  __name: 'text-field',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', payload: string): void;
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    class: "text-field",
    onInput: _cache[0] || (_cache[0] = ($event: any) => (
            emit('update:modelValue', ($event.target as HTMLInputElement).value)
        )),
    value: __props.modelValue
  }, null, 40, _hoisted_1))
}
}

})